import { render, staticRenderFns } from "./StatusSwitcher.vue?vue&type=template&id=0cc328c8"
import script from "./StatusSwitcher.vue?vue&type=script&lang=js"
export * from "./StatusSwitcher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports